<template>
  <CommonLayout selectedNav="codec">
    <div class="tx-wrap">
      <div class="tx-hero tx-hero-left">
        <h1 class="tx-hero-title">编码 <em>工具箱</em></h1>
        <p class="tx-hero-sub">Base64 · Hex · URL · Unicode · HTML实体 · 字符集（实时转换）</p>
      </div>

      <div class="tx-panel tx-codec-panel">
        <span class="tx-corner tl"></span><span class="tx-corner tr"></span>
        <span class="tx-corner bl"></span><span class="tx-corner br"></span>

        <div class="tx-codec-bar">
          <div class="tx-field-label">// 转换类型 TYPE</div>
          <el-select v-model="type" class="tx-codec-select">
            <el-option v-for="t in typeOptions" :key="t.v" :label="t.t" :value="t.v"></el-option>
          </el-select>

          <template v-if="type !== 'charset'">
            <el-radio-group v-model="dir" size="small" class="tx-codec-dir">
              <el-radio-button label="encode">编码</el-radio-button>
              <el-radio-button label="decode">解码</el-radio-button>
            </el-radio-group>
          </template>
          <template v-else>
            <el-select v-model="charset" class="tx-codec-select">
              <el-option v-for="c in charsetOptions" :key="c.v" :label="c.t" :value="c.v"></el-option>
            </el-select>
          </template>

          <el-upload class="tx-codec-file" :auto-upload="false" :show-file-list="false"
            :on-change="loadFile">
            <el-button size="small" class="tx-mini-btn"><i class="el-icon-folder-opened"></i> 载入文件</el-button>
          </el-upload>
        </div>

        <el-row :gutter="18" class="tx-codec-io">
          <el-col :xs="24" :md="12">
            <div class="tx-io-label">
              <span>输入 INPUT</span>
              <span class="tx-io-meta">{{ inputLen }} 字符</span>
            </div>
            <el-input type="textarea" v-model="input" :rows="12" class="tx-codec-area"
              :placeholder="placeholder"></el-input>
          </el-col>
          <el-col :xs="24" :md="12">
            <div class="tx-io-label">
              <span>输出 OUTPUT</span>
              <el-link type="success" :underline="false" class="tx-copy" @click="copyOut" v-if="output.text">
                <i class="el-icon-document-copy"></i> 复制
              </el-link>
              <el-link type="info" :underline="false" class="tx-swap" @click="swap" v-if="output.text">
                <i class="el-icon-right"></i> 转回输入
              </el-link>
            </div>
            <el-input type="textarea" :value="output.text" :rows="12" class="tx-codec-area" readonly
              placeholder="结果将实时显示在这里"></el-input>
          </el-col>
        </el-row>

        <div class="tx-codec-err" v-if="output.error">
          <i class="el-icon-warning"></i> {{ output.error }}
        </div>
      </div>
    </div>
  </CommonLayout>
</template>

<style scoped>
.tx-wrap {
  max-width: 1080px;
  margin: 0 auto;
  padding: 36px 28px 60px;
  animation: txFadeUp .5s ease both;
}

@keyframes txFadeUp {
  from {
    opacity: 0;
    transform: translateY(14px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tx-hero-left {
  text-align: left;
  margin-bottom: 26px;
}

.tx-hero-title {
  margin: 0 0 8px;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 4px;
  color: #e2f5ff;
}

.tx-hero-title em {
  font-style: normal;
  background: linear-gradient(90deg, #22d3ee, #818cf8, #22d3ee);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: txShine 4s linear infinite;
}

@keyframes txShine {
  to {
    background-position: 200% center;
  }
}

.tx-hero-sub {
  margin: 0;
  color: #5b7295;
  font-size: 13px;
  letter-spacing: 1px;
}

.tx-codec-panel {
  position: relative;
  padding: 22px;
  border-radius: 16px;
  background: rgba(13, 20, 36, .72);
  border: 1px solid rgba(56, 189, 248, .22);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 18px 50px rgba(0, 0, 0, .45);
}

.tx-corner {
  position: absolute;
  width: 14px;
  height: 14px;
  border-color: #22d3ee;
  border-style: solid;
  border-width: 0;
  filter: drop-shadow(0 0 4px rgba(34, 211, 238, .7));
}

.tx-corner.tl { top: -1px; left: -1px; border-top-width: 2px; border-left-width: 2px; }
.tx-corner.tr { top: -1px; right: -1px; border-top-width: 2px; border-right-width: 2px; }
.tx-corner.bl { bottom: -1px; left: -1px; border-bottom-width: 2px; border-left-width: 2px; }
.tx-corner.br { bottom: -1px; right: -1px; border-bottom-width: 2px; border-right-width: 2px; }

.tx-codec-bar {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.tx-codec-select {
  width: 180px;
}

.tx-codec-select .el-input__inner,
.tx-codec-dir .el-radio-button__inner {
  background: rgba(7, 12, 24, .6);
  border-color: rgba(56, 189, 248, .3) !important;
  color: #e2f5ff;
}

.tx-codec-dir .el-radio-button__inner {
  letter-spacing: 1px;
}

.tx-mini-btn {
  background: rgba(34, 211, 238, .1) !important;
  border: 1px solid rgba(34, 211, 238, .35) !important;
  color: #a5f3fc !important;
}

.tx-codec-file {
  margin-left: auto;
}

.tx-codec-io {
  align-items: stretch;
}

.tx-io-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #8fd8ee;
  font-size: 12px;
  letter-spacing: 2px;
  margin-bottom: 8px;
}

.tx-io-meta {
  color: #5b7295;
  letter-spacing: 0;
}

.tx-codec-area {
  font-family: Consolas, Monaco, monospace;
}

.tx-codec-area >>> .el-textarea__inner,
.tx-codec-area .el-textarea__inner {
  background: rgba(7, 12, 24, .6) !important;
  border: 1px solid rgba(56, 189, 248, .3) !important;
  color: #c7d7ee !important;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.6;
}

.tx-copy,
.tx-swap {
  font-size: 12px;
  margin-left: 10px;
}

.tx-copy {
  color: #34d399 !important;
}

.tx-swap {
  color: #22d3ee !important;
}

.tx-codec-err {
  margin-top: 12px;
  color: #fca5a5;
  font-size: 12.5px;
  background: rgba(248, 113, 113, .08);
  border: 1px solid rgba(248, 113, 113, .25);
  border-radius: 8px;
  padding: 8px 12px;
}

@media (max-width: 768px) {
  .tx-wrap {
    padding: 22px 14px 48px;
  }

  .tx-codec-file {
    margin-left: 0;
  }
}
</style>

<script>
import CommonLayout from './common/commonPage.vue';

export default {
  props: { selectedNav: { type: String, default: 'codec' } },
  components: { CommonLayout },
  data() {
    return {
      type: 'base64',
      dir: 'encode',
      charset: 'gbk',
      input: '',
      typeOptions: [
        { v: 'base64', t: 'Base64' },
        { v: 'hex', t: 'Hex 十六进制' },
        { v: 'url', t: 'URL 编码' },
        { v: 'unicode', t: 'Unicode 转义' },
        { v: 'html', t: 'HTML 实体' },
        { v: 'charset', t: '字符集解码' },
      ],
      charsetOptions: [
        { v: 'gbk', t: 'GBK / GB2312' },
        { v: 'big5', t: 'Big5' },
        { v: 'shift_jis', t: 'Shift-JIS' },
        { v: 'iso-8859-1', t: 'ISO-8859-1' },
        { v: 'windows-1252', t: 'Windows-1252' },
      ],
    };
  },
  computed: {
    inputLen() {
      return (this.input || '').length;
    },
    placeholder() {
      const map = {
        base64: '输入待编码 / 解码的文本', hex: '输入文本或十六进制串', url: '输入文本或编码后的 URL',
        unicode: '输入文本或 \\uXXXX 转义串', html: '输入文本或 HTML 实体', charset: '输入字节文本（latin1）',
      };
      return map[this.type] || '输入文本';
    },
    output() {
      try {
        const text = this.transform(this.input);
        return { text, error: '' };
      } catch (e) {
        return { text: '', error: '转换失败：' + (e.message || e) };
      }
    },
  },
  methods: {
    transform(src) {
      if (this.type === 'charset') return this.charsetDecode(src, this.charset);
      const fn = this.fns[this.type][this.dir];
      return fn(src);
    },
    charsetDecode(src, label) {
      const bytes = new Uint8Array([...src].map((c) => c.charCodeAt(0) & 0xff));
      return new TextDecoder(label).decode(bytes);
    },
    loadFile(file) {
      const reader = new FileReader();
      reader.onload = () => {
        // 文本文件按 UTF-8 读入；二进制也可读为文本参与转换
        this.input = reader.result;
      };
      reader.readAsText(file.raw, 'utf-8');
    },
    copyOut() {
      if (!this.output.text) return;
      const ta = document.createElement('textarea');
      ta.value = this.output.text;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); this.$message.success('已复制'); } catch (e) { this.$message.warning('复制失败'); }
      document.body.removeChild(ta);
    },
    swap() {
      this.input = this.output.text;
    },
  },
  created() {
    // 纯函数实现（前端本地，支持中文）
    this.fns = {
      base64: {
        encode: (s) => btoa(unescape(encodeURIComponent(s))),
        decode: (s) => decodeURIComponent(escape(atob(s.trim()))),
      },
      hex: {
        encode: (s) => Array.from(new TextEncoder().encode(s)).map((b) => b.toString(16).padStart(2, '0')).join(' '),
        decode: (s) => {
          const clean = s.replace(/[^0-9a-fA-F]/g, '');
          if (clean.length % 2 !== 0) throw new Error('十六进制长度必须为偶数');
          const bytes = new Uint8Array(clean.match(/.{2}/g).map((h) => parseInt(h, 16)));
          return new TextDecoder('utf-8').decode(bytes);
        },
      },
      url: {
        encode: (s) => encodeURIComponent(s),
        decode: (s) => decodeURIComponent(s.trim()),
      },
      unicode: {
        encode: (s) => {
          let out = '';
          for (const ch of s) {
            const cp = ch.codePointAt(0);
            if (cp > 0x7f) out += '\\u' + cp.toString(16).padStart(4, '0');
            else out += ch;
          }
          return out;
        },
        decode: (s) => s.replace(/\\u([0-9a-fA-F]{1,4})/g, (_, h) => String.fromCharCode(parseInt(h, 16))),
      },
      html: {
        encode: (s) => s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])),
        decode: (s) => s.replace(/&(amp|lt|gt|quot|#39|#x27);/g, (_, e) => ({ amp: '&', lt: '<', gt: '>', quot: '"', '#39': "'", '#x27': "'" }[e])),
      },
    };
  },
};
</script>
